import { Accordion } from "react-bootstrap";
import { FormFieldTypes } from "../../../components/forms/libs/data/formFieldType";
import { validationTypes } from "../../../components/forms/libs/data/ValidationTypes";
import Buttons from "../../../components/ui/button/Buttons";
import { AppIcons } from "../../../data/appIcons";
import TitleWrapper from "../../../components/ui/titlewrapper/TitleWrapper";
import AccordionWrapper from "../../../components/ui/accordion/AccordionWrapper";
import AdmissionBoardApprovalForm from "../component/AdmissionBoardApprovalForm";
import BoardcommitteeApprovalForm from "../component/BoardcommitteeApprovalForm";
import GeneratePDFForMember from "../GeneratePDFForMember";


const initState = {
    membershipType: null,
    transactionType: "",
    subscriptionStartDate: "",
    subscriptionEndDate: "",
    lastUpdatedDate: "",
    lastUpdatedDate: "",

    comments: "",
    deadline: "",
    lastUpdatedDate: "",
    additionalNotes: "",
    admissionCommitteeDate: "",
    lastUpdatedDate: "",


    secretariatSummary: "",
    deadline: "",
    lastUpdatedDate: "",
    additionalNotes: "",
    additionalNotes: "",

    boardApprovalDate: "",
    subscriptionStartDate: "",
    boardApprovalDate: "",
    boardApprovalDate: "",

    selectedSubscriptionStartDate: ""
};

export const EditUpgradeMembershipTaskListFormData = {
    name: "EditMembershipTaskListFormData",
    initialState: initState,
    section: [
        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "vertical-form mb-3 form-card row",
            },

            wrapperTemplate: (
                <TitleWrapper
                    title="Account Information"
                    wrapperButton={<GeneratePDFForMember />}
                />
            ),

            fields: [
                {
                    id: "membershipType",
                    label: "Membership Type",
                    Field_Name: "Membership Type",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "membershipType",
                    fieldSetting: {
                        placeholder: "Select",
                        // allowSpace: true,
                        // isDisable: true,
                        options: [
                            // { label: "City 1", value: 1 },
                            // { label: "City 2", value: 2 },
                            // { label: "City 3", value: 3 },
                        ],
                    },
                    style: {
                        containerCss: "col-lg-9 col-md-9 validation-left-0",
                    },
                },
                {
                    id: "transactionType",
                    label: "Transaction Type",
                    Field_Name: "Transaction Type",
                    fieldType: FormFieldTypes.SELECT,
                    dataField: "transactionType",
                    fieldSetting: {
                        placeholder: "Select",
                        allowSpace: true,
                        isDisable: true,
                        options: [
                            // { label: "City 1", value: 1 },
                            // { label: "City 2", value: 2 },
                            // { label: "City 3", value: 3 },
                        ],
                    },
                    style: {
                        containerCss: "col-lg-9 col-md-9 validation-left-0",
                    },
                },
                {
                    id: "subscriptionStartDate",
                    label: "Subscription Start Date",
                    Field_Name: "Subscription Start Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "subscriptionStartDate",
                    fieldSetting: {
                        allowSpace: true,
                        isDisable: true,
                        placeholder: "Select",
                    },
                    style: {
                        containerCss: "col-lg-9 col-md-9 validation-left-0 mb-2",
                    },
                },
                {
                    id: "subscriptionEndDate",
                    label: "Subscription End Date",
                    Field_Name: "Subscription End Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "subscriptionEndDate",
                    fieldSetting: {
                        allowSpace: true,
                        isDisable: true,
                        placeholder: "Select",
                    },
                    style: {
                        containerCss: "col-lg-9 col-md-9 validation-left-0 mb-2",
                    },
                },
                {
                    id: "lastUpdatedDate",
                    label: "Last Updated Date",
                    Field_Name: "Last Updated Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "lastUpdatedDate",
                    fieldSetting: {
                        allowSpace: true,
                        isDisable: true,
                        placeholder: "Select",
                    },
                    style: {
                        containerCss: "col-lg-9 col-md-9 validation-left-0 mb-2",
                    },
                },
                {
                    id: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.DATEPICKER,
                    label: "",
                    dataField: "",
                    fieldSetting: {
                        allowSpace: true,
                        isDisable: false,
                        isFormControl: true,
                        isTemplateBtnDisable: false,
                        formControltemplate: (
                            <Buttons
                                actionName={"VIEW_UPGRADE_INFORMATION"}
                                buttonText={"View Upgrade Information"}
                                buttonTypeClassName="theme-btn right-side-form-btn"
                                isTextWithIcon={true}
                                btnIcon={AppIcons.plusIcon} // Attach the dynamic onClick handler here
                            />
                        ),
                    },
                    style: {
                        containerCss: "col-lg-3 col-md-3 blank-field blank-field-with-btn",
                    },
                },
            ],
        },
        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "vertical-form mb-3 form-card row",
            },
            wrapperTemplate: <AccordionWrapper title="Admission Committee Approval" id="1" />,
            fields: [
                {
                    id: "",
                    label: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.MAINFORMTITLE,
                    dataField: "",
                    fieldSetting: {
                        isFormControl: true,
                        isDisable: true,
                        formControltemplate: <AdmissionBoardApprovalForm />,
                    },
                    style: {
                        containerCss:
                            "col-lg-12 col-md-12 ",
                    },
                },
            ],
        },

        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "vertical-form mb-3 form-card row",
            },

            wrapperTemplate: <AccordionWrapper title="Board of Directors Approval" id="2" />,

            fields: [

                {
                    id: "",
                    label: "",
                    Field_Name: "",
                    fieldType: FormFieldTypes.MAINFORMTITLE,
                    dataField: "",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "Select",
                        isFormControl: true,
                        formControltemplate: <BoardcommitteeApprovalForm />,
                    },
                    style: {
                        containerCss:
                            "col-lg-12 col-md-12 ",
                    },
                },
            ],
        },
        {
            title: "User Information Section",
            row: {},
            style: {
                sectionStyle: "vertical-form mb-3 form-card row",
            },

            wrapperTemplate: (
                <TitleWrapper
                    title="Additional Information"
                // wrapperButton="Generate PDF"
                />
            ),
            fields: [
                {
                    id: "selectedSubscriptionStartDate",
                    label: "Subscription Start Date",
                    Field_Name: "Subscription Start Date",
                    fieldType: FormFieldTypes.DATEPICKER,
                    dataField: "selectedSubscriptionStartDate",
                    fieldSetting: {
                        allowSpace: true,
                        placeholder: "Select",
                    },
                    validation: [{ type: validationTypes.REQUIRE }],
                    style: {
                        containerCss: "col-lg-9 col-md-9 validation-left-0 mb-2",
                    },
                },
            ],
        },
    ],
    formSetting: {
        isViewOnly: false,
    }
};
